import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { DataService } from './services/data-service';
import { IUserStore } from './redux/user/types';
import { useDispatch } from 'react-redux';
import { LoginUser } from './redux/user/userReducer';
import { Protected } from './Protected';
// import LoginPage from "./auth-pages/Login";
import { getUserToken } from './helpers/user-token';
import { CircularProgress } from '@mui/material';
import Loader from './components/Loader';
import BaseLayout from './layouts/BaseLayout';
import LoginPage from './pages/auth-pages/Login';

interface IUserDetailsResponse {
  success: boolean;
  message: string;
  data: {
    email: string;
    active: boolean;
    role?: string;
    id: number;
    name: string;
  };
}

export const Portal: React.FC = () => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    DataService.get('api/User/details')
      .then(async (res) => {
        if (res.ok) {
          const result: IUserDetailsResponse = await res.json();
          if (result.success)
            var newStore: IUserStore = {
              token: getUserToken() || '',
              isAuthenticated: true,
              user: {
                email: result.data.email,
                id: result.data.id.toString(),
                name: result.data.name,
                role: result.data.role || '',
              }
            };
          dispatch(LoginUser(newStore));
          setTimeout(() => {
            setLoaded(true);
          }, 500);
          setLoaded(true);
        } else {
          setLoaded(true);
        }
      })
      .catch(() => {
        setLoaded(true);
      });
  }, []);

  return loaded ? (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="*" element={<Protected />} />
    </Routes>
  ) : (
    <Loader />
  );
};
